module.exports = __webpack_public_path__ + "static/media/Outlets.39897121.png";